const MOBILE_MENU_HEIGHT = 55;
const DESKTOP_MENU_HEIGHT = 64;
const NON_AUTH_MOBILE_MENU_HEIGHT = 64;
const NON_AUTH_DESKTOP_MENU_HEIGHT = 64;

export default {
  size: {
    mobile: {
      menuHeight: MOBILE_MENU_HEIGHT,
      mainPaperHeight: `calc(var(--vh, 1vh) * 100 - ${MOBILE_MENU_HEIGHT}px)`,
      NonAuthMenuHeight: NON_AUTH_MOBILE_MENU_HEIGHT,
      NonAuthPaperHeight: `calc(var(--vh, 1vh) * 100 - ${NON_AUTH_MOBILE_MENU_HEIGHT}px)`,
    },
    desktop: {
      menuHeight: DESKTOP_MENU_HEIGHT,
      mainPaperHeight: `calc(100vh - ${DESKTOP_MENU_HEIGHT}px)`,
      NonAuthMenuHeight: NON_AUTH_DESKTOP_MENU_HEIGHT,
      mainPaperHeNonAuthPaperHeightight: `calc(100vh - ${NON_AUTH_DESKTOP_MENU_HEIGHT}px)`,
    },
  },
  spacing: 8,
};



// WEBPACK FOOTER //
// ./src/layouts/ThemeProvider/settings.js